import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export function usePurchaseNonProfitable(briefId: string) {
  const {
    mutate: purchaseNonProfitable,
    isLoading: isPurchasingNonProfitable,
    isSuccess: isPurchasedNonProfitable,
    variables,
  } = useMutation({
    mutationFn: (briefInfluencerId: string) =>
      BriefService.purchaseNonProfitable(briefInfluencerId).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      ),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
      });

      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY, "facets", briefId],
      });
    },
  });

  return {
    purchaseNonProfitable,
    isPurchasingNonProfitable,
    isPurchasedNonProfitable,
    variables,
  };
}
